import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import ActivityCard from './activity-card/activity-card';
import CatalogPullOut from '../catalog-pull-out/catalog-pull-out';
import { searchAPI } from '@/providers/apis/search/search';

@Component({
    name: 'gooru-search-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'activity-card': ActivityCard,
        'catalog-pull-out': CatalogPullOut,
    },
})

export default class GooruSearchCard extends Vue {

    // -------------------------------------------------------------------------
    // Properties

    private selectedContent: any = null;

    @Prop()
    private activityContents: any;

    @Prop()
    private filterParams: any;


    private sortedContents: any = [];

    private collectionData: any = null;

    private isPullOutLoading: boolean = false;

    private isLoading: boolean = false;

    private start: number = 1;

    private length: number = 10;
    // -----------------------------------------------------------
    // Methods

    /**
     * @function sortGooruSearch used to sort gooru search result
     */
    public sortGooruSearch(activityContents: any) {
        let activityList = [];
        if (this.sortedContents.length === 0) {
            const selectedResourse = this.mixSelectedActivities(
                activityContents.resource,
            );
            const selectedQuestion = this.mixSelectedActivities(
                activityContents.question,
            );
            const selectedAssessment = this.mixSelectedActivities(
                activityContents.assessment,
            );
            const selectedCollection = this.mixSelectedActivities(
                activityContents.collection,
            );
            const selectedOfflineActivity = this.mixSelectedActivities(
                activityContents.offlineActivity,
            );
            activityList = [
                ...selectedCollection,
                ...selectedAssessment,
                ...selectedOfflineActivity,
                ...selectedResourse,
                ...selectedQuestion,
            ];
            this.sortedContents = this.sortedContents.concat(activityList);
        }
        this.shuffleContainer();
    }


    /**
     * @function mixSelectedActivities used to mix selected activity data
     */
    public mixSelectedActivities(content: any) {
        return content.length ? [content.shift()] : [];
    }

    /**
     * @function mixOtherActivities used to mix other activity data
     */
    public mixOtherActivities(content: any) {
        return content.length > 1
            ? content.splice(0, 2)
            : content.length
                ? [content.shift()]
                : [];
    }

    /**
     * @function shuffle used to suffle acitivity datas
     */
    public shuffleContainer() {
        const activityContents = this.activityContents;

        if (
            activityContents.assessment.length ||
            activityContents.collection.length ||
            activityContents.question.length ||
            activityContents.resource.length
        ) {
            const otherCollection = this.mixOtherActivities(
                activityContents.collection,
            );
            const otherAssessment = this.mixOtherActivities(
                activityContents.assessment,
            );
            const otherQuestion = this.mixOtherActivities(activityContents.question);
            const otherResourse = this.mixOtherActivities(activityContents.resource);
            const otherOfflineActivity = this.mixOtherActivities(
                activityContents.offlineActivity,
            );
            const result = [
                ...otherCollection,
                ...otherAssessment,
                ...otherOfflineActivity,
                ...otherResourse,
                ...otherQuestion,
            ];
            this.sortedContents = this.sortedContents.concat(result);
            this.shuffleContainer();
        }

        return false;
    }

    @Watch('filterParams', {deep: true})
    private onChangeFilter(value: any) {
        this.sortedContents = [];
        this.sortGooruSearch(this.activityContents);
    }

    @Watch('activityContents')
    private onChangeActivity(value: any) {
       if (Object.keys(value).length) {
        this.sortGooruSearch(value);
       }
    }

    // -------------------------------------------------------------
    // Hooks
    private created() {
        this.sortedContents = [];
    }

    // -----------------------------------------------------------------------
    // Actions
    private openPullOut(content: any) {
        this.isPullOutLoading = true;
        this.collectionData = null;
        document.body.style.overflow = 'hidden';
        (this.$el.querySelector('.catalog-pull-out-container') as HTMLElement).style.left = 'calc(100vw - 450px)';
        this.onLoadContent(content).then((collections) => {
            this.collectionData = collections;
            this.isPullOutLoading = false;

        });
    }

    private onScrollhandle(e: any) {
        const params: any = this.filterParams;
        const currentScrollPosition = e.srcElement.scrollTop;
        if (currentScrollPosition >= (e.srcElement.scrollHeight - e.srcElement.offsetHeight) && !this.isLoading) {
            this.isLoading = true;
            this.start = this.start + 1;
            params.length = this.length;
            delete params.start;
            params.start = this.start;
            this.$store.dispatch('comparativeStore/comparativeSearch', params).then(() => {
                this.isLoading = false;
            });
        }
    }

    private onLoadContent(content: any) {
        const contentType = content.type;
        if (contentType === 'collection') {
            return searchAPI.fetchCollections({ q: content.id })
                .then((collections) => {
                     return collections.searchResults[0];
                });
        } else if (contentType === 'assessment') {
            return searchAPI.fetchAssessment({ q: content.id })
                .then((collections) => {
                    return collections.searchResults[0];
                });
        } else if (contentType === 'resource') {
            return searchAPI.fetchResources({ q: content.id }).then((resourceData) => {
                return resourceData.searchResults[0];
            });
        } else if (contentType === 'question') {
            return searchAPI.fetchQuestions({ q: content.id }).then((questionData) => {
                return questionData.searchResults[0];
            });
        } else if (contentType === 'offline-activity') {
            return searchAPI.fetchOfflineActivity({ q: content.id }).then((activityData) => {
                return activityData.searchResults[0];
            });
        } else {
            return searchAPI.fetchCollections({ q: content.id })
            .then((collections) => {
                 return collections.searchResults[0];
            });
        }

    }

}
